export default "__VITE_ASSET__DW3if7Uw__"